<template>
  <div>
    <year-selector-constraint
      v-if="type === optionValue.year"
      :allowed-values.sync="yearAllowedValues"
      :forbidden-values.sync="yearForbiddenValues"
    />
    <month-selector-constraint
      v-else-if="type === optionValue.month"
      :allowed-values.sync="monthAllowedValues"
      :forbidden-values.sync="monthForbiddenValues"
    />
    <day-selector-constraint
      v-else-if="type === optionValue.day"
      :allowed-values.sync="dayAllowedValues"
      :forbidden-values.sync="dayForbiddenValues"
    />
  </div>
</template>

<script>
import YearSelectorConstraint from "@/components/excel/designer/configure/value/date/year-selector-constraint";
import MonthSelectorConstraint from "@/components/excel/designer/configure/value/date/month-selector-constraint";
import DaySelectorConstraint from "@/components/excel/designer/configure/value/date/day-selector-constraint";
import {
  DayOption,
  MonthOption,
  YearOption,
} from "@/components/excel/schema/label/type/date";

export default {
  name: "date-single-selector-constraint",
  components: {
    DaySelectorConstraint,
    MonthSelectorConstraint,
    YearSelectorConstraint,
  },
  props: {
    type: {
      type: Number,
    },
    forbiddenValues: {
      type: Array,
    },
    allowedValues: {
      type: Array,
    },
  },
  watch: {
    forbiddenValues(values) {
      this.year.forbiddenValues = [];
      this.month.forbiddenValues = [];
      this.day.forbiddenValues = [];
      switch (this.$props.type) {
        case this.optionValue.year:
          this.year.forbiddenValues = values || [];
          break;
        case this.optionValue.month:
          this.month.forbiddenValues = values || [];
          break;
        case this.optionValue.day:
          this.day.forbiddenValues = values || [];
      }
    },
    allowedValues(values) {
      this.year.allowedValues = [];
      this.month.allowedValues = [];
      this.day.allowedValues = [];
      switch (this.$props.type) {
        case this.optionValue.year:
          this.year.allowedValues = values || [];
          break;
        case this.optionValue.month:
          this.month.allowedValues = values || [];
          break;
        case this.optionValue.day:
          this.day.allowedValues = values || [];
      }
    },
  },
  computed: {
    yearAllowedValues: {
      get() {
        return this.year.allowedValues;
      },
      set(value) {
        const current = value || [];
        this.year.allowedValues = current;
        this.emitChangeAllowedValues(current);
      },
    },
    monthAllowedValues: {
      get() {
        return this.month.allowedValues;
      },
      set(value) {
        const current = value || [];
        this.month.allowedValues = current;
        this.emitChangeAllowedValues(current);
      },
    },
    dayAllowedValues: {
      get() {
        return this.day.allowedValues;
      },
      set(value) {
        const current = value || [];
        this.day.allowedValues = current;
        this.emitChangeAllowedValues(current);
      },
    },
    yearForbiddenValues: {
      get() {
        return this.year.forbiddenValues;
      },
      set(value) {
        const current = value || [];
        this.year.forbiddenValues = current;
        this.emitChangeForbiddenValues(current);
      },
    },
    monthForbiddenValues: {
      get() {
        return this.month.forbiddenValues;
      },
      set(value) {
        const current = value || [];
        this.month.forbiddenValues = current;
        this.emitChangeForbiddenValues(current);
      },
    },
    dayForbiddenValues: {
      get() {
        return this.day.forbiddenValues;
      },
      set(value) {
        const current = value || [];
        this.day.forbiddenValues = current;
        this.emitChangeForbiddenValues(current);
      },
    },
  },
  data() {
    return {
      year: {
        allowedValues: null,
        forbiddenValues: null,
      },
      month: {
        allowedValues: null,
        forbiddenValues: null,
      },
      day: {
        allowedValues: null,
        forbiddenValues: null,
      },
      optionValue: {
        year: YearOption.value,
        month: MonthOption.value,
        day: DayOption.value,
      },
    };
  },
  methods: {
    emitChangeAllowedValues(value) {
      this.$emit("update:allowed-values", value);
      this.$emit("change-allowed-values", value);
    },
    emitChangeForbiddenValues(value) {
      this.$emit("update:forbidden-values", value);
      this.$emit("change-forbidden-values", value);
    },
  },
};
</script>
